// ページ遷移のたびに実行される処理
// @ts-ignore
export default function ({ store }) {
  /**
   * loadingの際の画像&文字を表示する判定用valueをランダムに更新する
   */
  store.dispatch('loading/updateIconRandNum');
  store.dispatch('loading/updateTextRandNum');
}
